module.exports = __webpack_public_path__ + "img/filter-orientation.2ce20b83.png";